import RpcClass from "../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.model.plm.TranchePlanView';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class TranchePlanView extends RpcClass{

    /**
     *  @class TranchePlanView
     *  @alias module:src/server/com/silkplm/model/plm/TranchePlanView.TranchePlanView
     *  
     * */
    constructor(){
        super();

        /** @type {boolean}  */
        this.collectObjectNodes = null;
        /** @type {boolean}  */
        this.collectRawValues = null;
        /** @type {Object.<*, Object.<string, module:src/server/com/silkplm/engine/forms/schema/definition/ComputedLink.ComputedLink>>}  */
        this.computedLinks = null;
        /** @type {Object.<string, *>}  */
        this.computedValues = null;
        /** @type {Object.<*, module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}  */
        this.dataByClass = null;
        /** @type {Object.<string, module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}  */
        this.dataByClassShortId = null;
        /** @type {Object}  */
        this.fieldValues = null;
        /** @type {string}  */
        this.fullId = null;
        /** @type {Object.<string, *>}  */
        this.rawValues = null;
        /** @type {module:src/server/com/silkplm/engine/entities/Supplement.Supplement}  */
        this.supplement = null;
        /** @type {*}  */
        this.watches = null;

    }





    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/TranchePlanView.TranchePlanView}
     */
    withCollectObjectNodes(val){
        this.collectObjectNodes = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/TranchePlanView.TranchePlanView}
     */
    withCollectRawValues(val){
        this.collectRawValues = val;
        return this;
    };


    /**
     * @param val {Object.<*, Object.<string, module:src/server/com/silkplm/engine/forms/schema/definition/ComputedLink.ComputedLink>>}
     * @returns {module:src/server/com/silkplm/model/plm/TranchePlanView.TranchePlanView}
     */
    withComputedLinks(val){
        this.computedLinks = val;
        return this;
    };


    /**
     * @param val {Object.<string, *>}
     * @returns {module:src/server/com/silkplm/model/plm/TranchePlanView.TranchePlanView}
     */
    withComputedValues(val){
        this.computedValues = val;
        return this;
    };


    /**
     * @param val {Object.<*, module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}
     * @returns {module:src/server/com/silkplm/model/plm/TranchePlanView.TranchePlanView}
     */
    withDataByClass(val){
        this.dataByClass = val;
        return this;
    };


    /**
     * @param val {Object.<string, module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}
     * @returns {module:src/server/com/silkplm/model/plm/TranchePlanView.TranchePlanView}
     */
    withDataByClassShortId(val){
        this.dataByClassShortId = val;
        return this;
    };


    /**
     * @param val {Object}
     * @returns {module:src/server/com/silkplm/model/plm/TranchePlanView.TranchePlanView}
     */
    withFieldValues(val){
        let rawValue = val;
        let v = val;
        v = rawValue
        this.fieldValues = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/TranchePlanView.TranchePlanView}
     */
    withFullId(val){
        this.fullId = val;
        return this;
    };


    /**
     * @param val {Object.<string, *>}
     * @returns {module:src/server/com/silkplm/model/plm/TranchePlanView.TranchePlanView}
     */
    withRawValues(val){
        this.rawValues = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/entities/Supplement.Supplement}
     * @returns {module:src/server/com/silkplm/model/plm/TranchePlanView.TranchePlanView}
     */
    withSupplement(val){
        this.supplement = val;
        return this;
    };


    /**
     * @param val {*}
     * @returns {module:src/server/com/silkplm/model/plm/TranchePlanView.TranchePlanView}
     */
    withWatches(val){
        this.watches = val;
        return this;
    };





    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};
metadata['collectObjectNodes'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['collectRawValues'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['computedLinks'] = {'remoteType' : 'Object.<*, Object.<string, module:src/server/com/silkplm/engine/forms/schema/definition/ComputedLink.ComputedLink>>', 'jsType' : 'Object.<*, Object.<string, module:src/server/com/silkplm/engine/forms/schema/definition/ComputedLink.ComputedLink>>', 'mapped' : 'false'};
metadata['computedValues'] = {'remoteType' : 'Object.<string, *>', 'jsType' : 'Object.<string, *>', 'mapped' : 'false'};
metadata['dataByClass'] = {'remoteType' : 'Object.<*, module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>', 'jsType' : 'Object.<*, module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>', 'mapped' : 'false'};
metadata['dataByClassShortId'] = {'remoteType' : 'Object.<string, module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>', 'jsType' : 'Object.<string, module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>', 'mapped' : 'false'};
metadata['fieldValues'] = {'remoteType' : 'com.fasterxml.jackson.databind.node.ObjectNode', 'jsType' : 'Object', 'mapped' : 'true'};
metadata['fullId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['rawValues'] = {'remoteType' : 'Object.<string, *>', 'jsType' : 'Object.<string, *>', 'mapped' : 'false'};
metadata['supplement'] = {'remoteType' : 'module:src/server/com/silkplm/engine/entities/Supplement.Supplement', 'jsType' : 'module:src/server/com/silkplm/engine/entities/Supplement.Supplement', 'mapped' : 'false'};
metadata['watches'] = {'remoteType' : '*', 'jsType' : '*', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.model.plm.TranchePlanView';
metadata.__type_short__ = 'TranchePlanView';
TranchePlanView.prototype.__metadata__ = metadata;

TranchePlanView.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/model/plm/TranchePlanView */
export default TranchePlanView

export { TranchePlanView }
